import React, { useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { usersApi } from '../_helpers/apiService';

interface SSNToggleProps {
  userId: number;
  defaultSSN?: string;
}

export const SSNToggle: React.FC<SSNToggleProps> = ({ userId, defaultSSN }) => {
  const [ssn, setSSN] = useState<string | null>(defaultSSN || null);
  const [isVisible, setIsVisible] = useState<boolean>(!!defaultSSN);
  const [loading, setLoading] = useState<boolean>(false);

  const handleViewSSN = async () => {
    if (isVisible) {
      return; // Already visible, do nothing
    }

    setLoading(true);
    try {
      const response = await usersApi.getSSN(userId);
      setSSN(response.data.ssn);
      setIsVisible(true);
    } catch (error) {
      console.error('Error fetching SSN:', error);
      message.error('Регистрийн дугаар татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  if (isVisible && ssn) {
    return <span>{ssn}</span>;
  }

  return (
    <Button
      type="link"
      icon={<EyeOutlined />}
      loading={loading}
      onClick={handleViewSSN}
      style={{ padding: 0 }}
    />
  );
};

export default SSNToggle;
